<template>
  <div id="app" @click="show = false">
    <Hearder @func="getMsg" :showData="show" id="header"></Hearder>
    <router-view
      @getAId="getAId"
      @getATType="getATType"
      @getATId="getATId"
      @getIsPlaying="getIsPlaying"
      @getClosePlaying="getClosePlaying"
      @getMemberBtn="getMemberBtn"
      v-if="isRouterAlive"
      @getFixed="getFixed"
      :showBtn="showBtn"
    />
    <Footer id="footer"></Footer>

    <Aplayer
      :audio_id="audio_id"
      :is_playing="is_playing"
      :audio_type_id="audio_type_id"
      :audio_type="audio_type"
      :member_btn="member_btn"
      @showPlayBtn="showPlayBtn"
    ></Aplayer>
    <div class="fixed" id="fixed">
      <div class="icon">
        <div class="icon-box">
          <img src="@/assets/img/icon_app.png" alt class="img" />
          <div class="icon-box-s">
            <div>
              <img src="@/assets/img/code_app.png" alt />
            </div>
            <p>下载app</p>
          </div>
        </div>
        <div class="icon-box">
          <img src="@/assets/img/icon_wechart1.png" alt class="img" />
          <div class="icon-box-s">
            <div>
              <img src="@/assets/img/code_weixin.png" alt />
            </div>
            <p>微信扫一扫</p>
            <p>关注我们的微信</p>
          </div>
        </div>
        <div class="icon-box">
          <img src="@/assets/img/icon_weibo.png" alt class="img" />
          <div class="icon-box-s">
            <div>
              <img src="@/assets/img/code_weibo.png" alt />
            </div>
            <p>微博扫一扫</p>
            <p>关注我们的微博</p>
          </div>
        </div>
        <div @click="top" class="icon-box" v-if="showTopBtn">
          <img src="@/assets/img/icon_top.png" alt class="img" />
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
document.write(
  unescape(
    "%3Cspan id='cnzz_stat_icon_1279846434'%3E%3C/span%3E%3Cscript src='https://s9.cnzz.com/z_stat.php%3Fid%3D1279846434' type='text/javascript'%3E%3C/script%3E"
  )
);
</script>
<script>
import Hearder from "./components/hearder";
import Footer from "./components/footer";
import Aplayer from "@/components/audio";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    Hearder,
    Footer,
    Aplayer
  },
  data() {
    return {
      show: false,
      audio_id: 0,
      audio_type_id: 0,
      audio_type: 0,
      is_playing: 0,
      member_btn: 0,
      isRouterAlive: true,
      showTopBtn: false,
      scroll: 0,
      i: 0,
      showBtn: true
    };
  },
  methods: {
    getIsPlaying() {
      this.is_playing++;
    },
    getClosePlaying() {
      this.is_playing = 0;
    },
    getMemberBtn(data) {
      this.member_btn = data;
    },
    getAId(data) {
      this.audio_id = data;
    },
    getATId(data) {
      this.audio_type_id = data;
    },
    getATType(data) {
      this.audio_type = data;
    },
    getMsg(data) {
      this.show = data;
    },
    getFixed(data) {
      var times = setTimeout(() => {
        if (data) {
          const right = document.querySelector(".content-r");
          const windowWidth = (document.body.clientWidth - 1200) / 2 + "px";

          var bodyReact = document.body.getBoundingClientRect();
          var rightTop = Math.abs(bodyReact.top) - 100 + "px";
          right.style.cssText =
            "position: absolute; top:" + rightTop + ";right:0";
        }
        clearTimeout(times);
      }, 1000);
    },
    showPlayBtn(data) {
      this.showBtn = data;
    },
    top() {
      scrollTo(0, 0);
      // var timer = setInterval(function() {
      //   let osTop =
      //     document.documentElement.scrollTop || document.body.scrollTop;
      //   let ispeed = Math.floor(-osTop / 5);
      //   document.documentElement.scrollTop = document.body.scrollTop =
      //     osTop + ispeed;
      //   this.isTop = true;
      //   if (osTop === 0) {
      //     clearInterval(timer);
      //   }
      // }, 30);
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    wrapListener() {
      const right = document.querySelector(".content-r");
      let header = document.getElementById("header");
      let footer = document.getElementById("footer");
      // 操作元素高度
      const rightHeight = right.offsetHeight;

      // 头部高度 - 底部和头部高度一致，不另元素获取
      // const topHeight = header.offsetHeight;
      const topHeight = 100;
      //视窗高度
      const windowHeight = window.innerHeight;
      const windowWidth = (document.body.clientWidth - 1200) / 2 + "px";
      //滚动总距离
      const scrollHeight = document.body.scrollHeight - windowHeight;

      // 上下触顶滑动开关
      let keyTop = false;
      let keyDown = true;
      // 初次加载开关
      let begin = true;

      /**
       * 元素初始定位
       * 注： 初始定位导致写在class中会导致，js重置css时，top，bottom这类字段不会被重置
       *     导致影响定位
       */
      right.style.cssText = "position: absolute; top:0px;right:0";
      /**
       * 监听滚动事件
       */
      let i = 0;
      window.removeEventListener("scroll", func, false);
      window.addEventListener("scroll", func, false);

      function func(e) {
        e.stopPropagation();
        // // 监听的元素

        var supportPageOffset = window.pageXOffset !== undefined;
        var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";

        var y = supportPageOffset
          ? window.pageYOffset
          : isCSS1Compat
          ? document.documentElement.scrollTop
          : document.body.scrollTop;

        const currentY = y - i;
        i = y;

        // 获取元素相对于视窗的定位
        var rectHeader = header.getBoundingClientRect();
        var rectRight = right.getBoundingClientRect();
        var rectFooter = footer.getBoundingClientRect();
        var bodyReact = document.body.getBoundingClientRect();
        /**
         * 功能
         *    向上滚动 --- 元素触顶贴顶吸附，向下滚动重置定位到当前位置，滚动到指定位置固定定位
         *    向下滚动 --- 元素触底贴底吸附，向上滚动重置定位到当前位置，滚动到指定位置固定定位
         *
         * 原理规则
         *    通过 elem.getBoundingClientRect 函数，获取元素top，bottom。
         *        top，对应元素顶部相对于视窗顶部距离
         *        bottom，对应元素底部部相对于视窗顶部距离
         *    获取视窗高度 window.innerHeight;
         *    触顶判断 - top = 0 时，判断为触顶 ； bottom ==  视窗高度 时，判断为触底
         *
         *    将元素绝对定位到当前位置实现
         *      获取body中getBoundingClientRect 数据 （ 定义为 bodyRect ）， 此时的数据时整个网页顶部距离视窗的高度
         *      bodyRect - 元素距离视窗的top ； 取绝对值（ body的top最大值是0 ），去掉头部的高度
         *      例： (bodyReact.top - rectRight.top) * -1 - 50 + "px"
         *
         **/

        //刷新时，判断元素是否处于触顶状态，不在触顶状态 - 绝对定位当前位置，保证元素不会重置样式
        if (begin) {
          begin = !begin;
          if (!(rectRight.bottom <= windowHeight || rectRight.top >= 0)) {
            right.style.cssText =
              "position: absolute; right:0;top:" +
              ((bodyReact.top - rectRight.top) * -1 - 50 + "px");
            return;
          }
        }
        if (rightHeight > 600) {
          if (currentY > 0) {
            //下滑
            /**
             * 绝对定位，保证反方向滑动不受触边吸附影响
             */
            if (parseInt(rectRight.top) == 0 && keyDown) {
              keyDown = false;
              right.style.cssText =
                "position:absolute;right:0;top:" +
                (Math.abs(rectHeader.top) - 50 + "px");
            }

            // 判断触边 （ 上滑触底，下滑触顶 ）
            if (parseInt(rectRight.bottom) <= windowHeight) {
              keyTop = true;
              right.style.cssText =
                "position: fixed;right:" + windowWidth + "; bottom: 0;";
            }
            if (parseInt(rectFooter.top) <= windowHeight) {
              right.style.cssText = "position: absolute;right:0; bottom: 0px;";
            }
          } else {
            //上滑
            /**
             * 绝对定位，保证反方向滑动不受触边吸附影响
             */

            if (parseInt(rectRight.bottom) == windowHeight - 30 && keyTop) {
              keyTop = false;
              right.style.cssText =
                "position:absolute;right:0;top:" +
                (y + windowHeight - rightHeight - 50 + "px");
            }

            // 判断触边 （ 上滑触底，下滑触顶 ）
            if (rectRight.top >= 0) {
              keyDown = true;

              right.style.cssText =
                "position: fixed;right:" + windowWidth + "; top: 100px";
            }
            if (rectHeader.bottom >= 0) {
              right.style.cssText = "position: absolute;right:0; top: 0; ";
            }
          }
        } else {
          right.style.cssText =
            "position:absolute;right:0;top:" +
            (Math.abs(rectHeader.top) + "px");
        }
      }
    }
  },
  watch: {
    $route: {
      handler(val, oldval) {
        if (val.name != oldval.name) {
          var time = setTimeout(() => {
            this.wrapListener();
            clearTimeout(time);
          }, 1000);
        }
      },
      deep: true
    }
  },
  mounted() {
    // window.addEventListener("scroll", this.wrapListener, true);
    var that = this;
    window.addEventListener("scroll", function() {
      var scrolls =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrolls >= 400) {
        that.showTopBtn = true;
      } else {
        that.showTopBtn = false;
      }
    });
    window.addEventListener("setItem", () => {
      if (localStorage.getItem("getFixeds") != null) {
        var times = setTimeout(() => {
          const right = document.querySelector(".content-r");
          const windowWidth = (document.body.clientWidth - 1200) / 2 + "px";

          const windowHeight = window.innerHeight;
          var bodyReact = document.body.getBoundingClientRect();
          var rectRight = right.getBoundingClientRect();
          var rightTop = Math.abs(bodyReact.top) + "px";
          if (parseInt(rectRight.bottom) <= windowHeight) {
            right.style.cssText =
              "position:absolute;right:0;top:" +
              (Math.abs(rectHeader.top) - 50 + "px");
          } else {
            right.style.cssText =
              "position: absolute; top:" + rightTop + ";right:0";
          }
          clearTimeout(times);
        }, 1000);
        localStorage.removeItem("getFixeds");
      }
    });
  }
};
</script>

<style>
@import "./assets/font/SOURCEHANSANSCN-REGULAR.css";
#app {
  min-width: 1200px;
  font-family: "SOURCEHANSANSCN-REGULAR", "Hiragino Sans GB", "Microsoft YaHei",
    "SimHei", "Helvetica", "Arial", "Tahoma", "sans-serif";
  -webkit-font-smoothing: none;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  margin: 0;
  padding: 0;
  background: #f5f5f5;
  font-size: 14px;
  position: relative;
}
body,
ul,
ol,
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}
ul,
ol,
li {
  list-style-type: none;
}
.main {
  /* width: 79%; */
  /* width: 72%; */
  margin: 0 auto;
  width: 1200px;
  padding-top: 70px;
  min-height: calc(100vh - 200px);
}
.main-content {
  display: flex;
  justify-content: space-between;
  position: relative;
}
.content-l {
  /* width: 73.5%; */
  /* width: 71%; */
  width: 850px;
  /* min-height: 800px; */
}
.content-r {
  width: 320px;
  margin-bottom: 30px;
  height: fit-content;
}
.fixed {
  position: fixed;
  right: 0;
  top: 40%;
}

.fixed .icon .icon-box {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f5f5f5;
  text-align: center;
  line-height: 52px;
  cursor: pointer;
  position: relative;
  /* margin-left: 35px; */
}
.fixed .icon .icon-box .icon-box-s {
  position: absolute;
  top: 0;
  right: 100%;
  background: #fff;
  border: 1px solid #d3d3d3;
  padding: 10px;
  display: none;
  margin-right: 20px;
  width: 140px;
}
.fixed .icon .icon-box .icon-box-s img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.fixed .icon .icon-box:hover .icon-box-s {
  display: block;
}
.fixed .icon .icon-box .icon-box-s div {
  height: 140px;
  margin-bottom: 10px;
}
.fixed .icon .icon-box .icon-box-s p {
  line-height: 20px;
}
.fixed .icon .icon-box .img {
  width: 100%;
}
.morePage {
  margin-top: 30px;
  margin-bottom: 40px;
  text-align: center;
  cursor: pointer;
}
.morePage p {
  font-size: 14px;
  font-weight: bold;
}

.morePage div {
  display: inline-block;
  margin-top: 5px;
}
/* .el-message {
  position: absolute;
  top: 50% !important;
  left: 50%;
  transform: translate(-50%, -50%);
} */
.is-disabled .el-input__inner {
  background: none !important;
}
figure {
  margin: 0;
}
figure img {
  width: 100%;
  height: 100%;
}
.el-button {
  border: none;
}
.el-loading-spinner {
  top: 20%;
}
.el-loading-spinner i {
  color: #fff;
  font-size: 30px;
}
.el-loading-spinner .el-loading-text {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue